import React, { useMemo } from "react";
import moment from "moment";
import SecurePassLogTypeTag from "@/components/SecurePass/SecurePassLogTypeTag/SecurePassLogTypeTag";

const useSecurePassSummaryColumns = () => {
  return useMemo(
    () => [
      {
        title: "Event Type",
        key: "type",
        dataIndex: "type",
        render: (text, record) => <SecurePassLogTypeTag logType={text} isSuccess={record.isSuccess} />,
      },
      {
        title: "Timestamp",
        key: "creationTime",
        dataIndex: "creationTime",
        render: text => (
          <span className="span-click">
            {text ? moment.utc(text).locale("en").local().format("M/D/YY, h:mm A") : ""}
          </span>
        ),
      },
      {
        title: "Comments",
        key: "comments",
        dataIndex: "comments",
        render: text => <span className="span-click">{text === "-" || !text ? "N/A" : text}</span>,
      },
    ],
    [],
  );
};

export default useSecurePassSummaryColumns;
